import { supabase } from './supabase';

/**
 * التسجيل الجديد: ينشئ حساب في نظام Auth ثم يدرج البيانات في جدول public.users
 */
export const signUp = async (email, password, fullName, role, phone) => {
    try {
        // 1. تسجيل المستخدم مع إضافة الهاتف للميتاداتا
        const { data: authData, error: authError } = await supabase.auth.signUp({
            email,
            password,
            options: {
                data: {
                    full_name: fullName,
                    role: role,
                    phone: phone // إضافة الهاتف هنا
                }
            },
        });

        if (authError) throw authError;

        // 2. إدراج البيانات في الجدول
        if (authData.user) {
            const { error: dbError } = await supabase
                .from('users')
                .insert([
                    {
                        id: authData.user.id,
                        full_name: fullName,
                        email: email,
                        role: role,
                        phone: phone // تسجيل الهاتف في الجدول
                    }
                ]);

            if (dbError) {
                console.error("DB Insert Error:", dbError);
                throw dbError;
            }
        }

        return { success: true, data: authData };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

/**
 * تسجيل الدخول: يجلب بيانات الـ Auth ثم يتأكد من جلب بيانات الجدول الخاص
 */
export const signIn = async (email, password) => {
    try {
        const { data, error } = await supabase.auth.signInWithPassword({
            email,
            password,
        });

        if (error) throw error;
        return { success: true, data };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

/**
 * تسجيل الخروج
 */
export const signOut = async () => {
    try {
        const { error } = await supabase.auth.signOut();
        if (error) throw error;
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

/**
 * الحصول على المستخدم الحالي: يدمج بيانات الـ Auth مع بيانات جدول public.users
 */
export const getCurrentUser = async () => {
    try {
        // جلب مستخدم الـ Auth الأساسي
        const { data: { user }, error: authError } = await supabase.auth.getUser();
        if (authError || !user) return null;

        // جلب البيانات التفصيلية من جدول users (الاسم والدور)
        const { data: profile, error: dbError } = await supabase
            .from('users')
            .select('*')
            .eq('id', user.id)
            .single();

        if (dbError) {
            console.warn('Profile not found in public.users table, returning auth metadata.');
            return user; // رجوع للميتاداتا لو الجدول لسه مش متحدث
        }

        // دمج البيانات (البريد من الـ Auth، والاسم/الدور من الجدول)
        return { ...user, profile };
    } catch (error) {
        console.error('Error getting current user:', error);
        return null;
    }
};

/**
 * الاستماع لتغييرات المصادقة
 */
export const onAuthStateChange = (callback) => {
    const { data } = supabase.auth.onAuthStateChange((event, session) => {
        if (!session?.user) {
            callback(null, event);
            return;
        }

        // 1. نبعت بيانات المستخدم الأساسية فوراً عشان الموقع يفتح وميعلقش
        callback(session.user, event);

        // 2. نجيب بيانات البروفايل في الخلفية ونحدث الحالة لما تجهز
        supabase
            .from('users')
            .select('*')
            .eq('id', session.user.id)
            .maybeSingle()
            .then(({ data: profile }) => {
                if (profile) {
                    // نبعت تحديث تاني بالبيانات الكاملة
                    callback({ ...session.user, profile }, event);
                }
            });
    });

    return data?.subscription?.unsubscribe;
};